<!-- <button (click)="click()">Click me</button>
<div *ngIf="isLoading">Loading...</div>
<pre style="text-wrap:wrap">{{response | json}}</pre> -->

<h1>Current Experiment: Technogym Invoicing</h1>
    <button mat-raised-button color="primary" (click)="createReport()" [disabled]="creatingReport">
        {{ creatingReport ? 'Creating Report...' : 'Create Report' }}
    </button>